import { normalizarTexto, tieneCaracteresInvalidos } from "../../../utilities/textValidations.js";

export { normalizarTexto, tieneCaracteresInvalidos };

export const existeSubproductoDuplicado = (subproductos, descripcion, unidad) => {
  const descNormalized = normalizarTexto(descripcion);

  return subproductos.some((p) => {
    const pDesc = normalizarTexto(p.descripcion);
    return pDesc === descNormalized && p.unidad === unidad;
  });
};
